module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-cade38c3b069c50cba214a25a408b958.png";